import { createSlice } from "@reduxjs/toolkit";


const UserInfoSlice=createSlice({
    name:"userInfo",
    initialState:{
        UserInfo:null
    },reducers:{
        SetDataUser:(state,action)=>{
            state.UserInfo=action.payload
        }
    }
})


export const {SetDataUser}=UserInfoSlice.actions;
export default UserInfoSlice.reducer;